export interface QuickViewVariant {
  id: number;
  title: string;
  available: boolean;
  price: number;
  compare_at_price: number | null;
  inventory_quantity: number;
  inventory_management: string | null;
  inventory_policy: string;
  options: string[];
}

export interface QuickViewOption {
  name?: string;
  position?: number;
  values?: string[];
}

export interface QuickViewProduct {
  id: number;
  title: string;
  handle: string;
  url?: string;
  product_type?: string;
  tags?: string[] | string;
  price: number;
  compare_at_price: number | null;
  images: string[];
  options: Array<string | QuickViewOption>;
  variants: QuickViewVariant[];
}

export function getUniqueOptionValues(
  product: QuickViewProduct,
  optionIndex: number
): string[] {
  const values = new Set<string>();
  for (const variant of product.variants) {
    const value = variant.options[optionIndex];
    if (value) {
      values.add(value);
    }
  }
  return Array.from(values);
}

export function getMatchingVariant(
  product: QuickViewProduct,
  selectedOptions: Array<string | null>
): QuickViewVariant | undefined {
  return product.variants.find((variant) =>
    variant.options.every((optionValue, index) => optionValue === selectedOptions[index])
  );
}
